import { render, staticRenderFns } from "./VehicleRevenue.vue?vue&type=template&id=546f8365&scoped=true"
import script from "./VehicleRevenue.vue?vue&type=script&lang=js"
export * from "./VehicleRevenue.vue?vue&type=script&lang=js"
import style0 from "./VehicleRevenue.vue?vue&type=style&index=0&id=546f8365&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f8365",
  null
  
)

export default component.exports